import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { ETNotification } from '@src/app/models/ETnotification';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationlistService {

  constructor(private http:HttpClient) { }

  getNotifications(date:Date){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    // GET /notification/{personId}/date/{date}
    return this.http.get<ETNotification[]>(environment.apiUrl+'/notification/'+SessionHelper.getUserSub()+'/date/'+ date.toISOString(),httpOptions);
  }

}
